// import React from "react";
import {
  // APISentSuccessMsg,
  getItemCreateSuccessMsg,
} from "../../../Constant/Message";
import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";

toast.configure();

const getTemplateShift = async (axiosInstance, formData) => {
  return await axiosInstance
    .post(`/sipeg/absensi/shift/template/`, formData, {
      responseType: "blob", 
    })
    .then((res) => {
      const filename = res.headers["content-disposition"]
        .split("filename=")[1]
        .replace(/['"]/g, "");
      const file = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const fileURL = URL.createObjectURL(file);
      const dom = document.createElement("a");
      dom.setAttribute("style", "display:none");
      dom.setAttribute("href", fileURL);
      dom.setAttribute("target", "_blank");
      dom.setAttribute("download", filename);
      document.body.appendChild(dom);
      dom.click();
      URL.revokeObjectURL(fileURL);
      document.body.removeChild(dom);
      toast.success(getItemCreateSuccessMsg("Template"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      return res;
    })
    .catch((error) => {
      console.error(error);
      toast.error(`GET Template ${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      throw error;
    });
};

export default getTemplateShift;
